import { post } from './api';
import { API_ENDPOINTS } from '@utils/constants';

/**
 * Contact Service
 * Handles all contact-related API calls
 */

/**
 * Submit contact form
 * @param {object} data - Contact form data
 * @returns {Promise} Response
 */
export const submitContactForm = async (data) => {
  try {
    const response = await post(API_ENDPOINTS.contact, data);
    return response;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};

/**
 * Submit quote request
 * @param {object} data - Quote request data
 * @returns {Promise} Response
 */
export const submitQuoteRequest = async (data) => {
  try {
    const response = await post(`${API_ENDPOINTS.contact}/quote`, data);
    return response;
  } catch (error) {
    console.error('Error submitting quote request:', error);
    throw error;
  }
};

export default {
  submitContactForm,
  submitQuoteRequest,
};